export interface IPromiseData {
  isActive: boolean;
  isResolved: boolean;
  isRejected: boolean;

  result: any;
  rejection: any;
}

export function queryPromise(promise: Promise<any>): IPromiseData {
  const promiseData: IPromiseData = {
    isActive: true,
    isResolved: false,
    isRejected: false,

    result: undefined,
    rejection: undefined,
  };

  promise.then(
    (result) => {
      promiseData.result = result;
      promiseData.isResolved = true;
      promiseData.isActive = false;

      return result;
    },
    (rejection) => {
      promiseData.rejection = rejection;
      promiseData.isRejected = true;
      promiseData.isActive = false;

      return Promise.reject(rejection);
    },
  );

  return promiseData;
}
